import React, { useEffect, useRef, useState } from "react";
import "./memberlist.scss";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import ModalUmum from "../../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";
import * as XLSX from "xlsx";
import moment from "moment";

function Memberlist() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [getDataSuccess, setGetDataSuccess] = useState(false);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [filterActive, setFilterActive] = useState();
  const [filterAllSuccess, setFilterAllSuccess] = useState("all");
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  let componentRef = useRef();
  const [modalShow, setModalShow] = useState(false);
  const [idUser, setIdUser] = useState();
  const [staff, setStaff] = useState()

  const idStaff = window.sessionStorage.getItem("dataLogin");

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/users");
    const restData = result.data.data;
    // delExpired(result.data.data);
    const dataActive = [];
    restData.forEach((item) => {
      if (item.active === true) {
        dataActive.push(item);
      }
    });
    setData(dataActive);
    //search auto complit
    const name = dataActive.map((value) => value.name);
    const email = dataActive.map((value) => value.email);
    const qrcode = dataActive.map((value) => value.qr);
    setAutoComplete(name.concat(email, qrcode));
    setGetDataSuccess(true);
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  };

  const handleNonActive = (id) => {
    setIdUser(id);
    setModalShow(true);
  };

  const getDataById = async (id) => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    return result;
  };

  //Handle Next
  const handleNext = async () => {
    const result = await getDataById(idUser);
    const dataUpdate = result.data.data[0];
    const data = new FormData();
    data.append("name", dataUpdate.name);
    data.append("phone", dataUpdate.phone);
    data.append("email", dataUpdate.email);
    data.append("birthday", dataUpdate.birthday);
    data.append("since", dataUpdate.since);
    data.append("expired", dataUpdate.expired);
    data.append("active", false);
    data.append("password", dataUpdate.password);
    data.append("gender", dataUpdate.gender);
    data.append("point", dataUpdate.point);
    data.append("statusMember", null);
    data.append("discount", null);

    await axios.put(`https://mobile.amospa.com/users/${idUser}`, data);
    setModalShow(false);
    await handlePostExpLog(idUser)

    await axios.post(`https://mobile.amospa.com/note`, {
      userId: idUser,
      staffName: staff.name,
      // catatan: note,
      keterangan: "Stop Member",
      // lastScan: catatan.lastScan,
      // visit: catatan.visit,
    });

    window.location.reload()
  };

  const getStaffById = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${idStaff}` },
    });
    const id = await rest.get("/jwt/token");
    let result = await axios.get(
      `https://mobile.amospa.com/staff/${id.data.data}`
    );
    setStaff(result.data.data[0]);
  };

  const handlePostExpLog = async(id)=>{
    if (id) {      
      const result = await getDataById(id);
      const dataUpdate = result.data.data[0];

      let rest = await axios.post(
        `https://mobile.amospa.com/explog`,
        {
          qr:dataUpdate.qr,
          userid:id,
          name:dataUpdate.name,
          phone:dataUpdate.phone,
          email:dataUpdate.email,
          since:dataUpdate.since,
          expired:dataUpdate.expired
        }
      );
    }

  }

  //handle otomatis expired on-active
  const delExpired = (dataUser) => {
    console.log('dataUser', dataUser);
    let today = new Date();
    dataUser.forEach(async (item) => {
      let exp = new Date(item.expired);
      if (today.getFullYear() > exp.getFullYear()) {
        handlePostExpLog(item.id)
        return await axios.put(`https://mobile.amospa.com/users/${item.id}`, {
          active: false,
        });
      }

      if (exp.getFullYear() === today.getFullYear()) {
        if (today.getMonth() + 1 > exp.getMonth() + 1) {
          handlePostExpLog(item.id)
          return await axios.put(`https://mobile.amospa.com/users/${item.id}`, {
            active: false,
          });
        } else if (today.getMonth() + 1 === exp.getMonth() + 1) {
          if (today.getDate() > exp.getDate()) {
            handlePostExpLog(item.id)
            return await axios.put(
              `https://mobile.amospa.com/users/${item.id}`,
              {
                active: false,
              }
            );
          }
        }
      }
    });
  };

  useEffect(() => {
    getData();
    getStaffById()
  }, [itemOffset, itemsPerPage, getDataSuccess, modalShow]);

  useEffect(()=>{
    setTimeout(() => {
      delExpired(data)
    }, 12000);
  },[])

  //Handle search
  const keys = ["name", "qr", "email"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const showData = filterActive ? filterActive : currentItems;
  const member = handleSearch();
  const dataTable = member ? member : showData;

  const clickLog = (id) => {
    window.localStorage.setItem("logId", JSON.stringify(id));
    window.localStorage.setItem("expLog", JSON.stringify(false));

    navigate("/homepage/members/log/");
  };

  //pagination
  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  //Header csv
  const headers = [
    { label: "QR Code", key: "qr" },
    { label: "Name", key: "name" },
    { label: "Phone", key: "phone" },
    { label: "Email", key: "email" },
    { label: "Member Since", key: "since" },
    { label: "Member Expired", key: "expired" },
  ];

  //XLSX
  const handleExportXlsx = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataTable);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");

    XLSX.writeFile(wb, "Member.xlsx");
  };


  return (
    <div className="member-list">
      <div className="member-list-header pb-4">
        <span className="d-flex align-items-center">
          <h3 className="text-white">List Of Members</h3>
          <p className="list-show mx-2">
            <select onChange={(e) => setitemsPerPage(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </p>
        </span>
        <span className="d-flex">
          <button
            onClick={handleExportXlsx}
            className="btn text-decoration me-1"
            style={{
              background: "#FFD700",
              color: "black",
              outline: "none",
            }}
          >
            XLSX
          </button>
          <CSVLink
            data={dataTable}
            headers={headers}
            filename="Member AMO"
            className="btn text-decoration-none me-1"
            separator={";"}
            style={{ background: "#FFD700" }}
          >
            CSV
          </CSVLink>
          <ReactToPrint
            trigger={() => {
              return (
                <button
                  className="btn text-decoration me-1"
                  style={{
                    background: "#FFD700",
                    color: "black",
                  }}
                >
                  Print
                </button>
              );
            }}
            content={() => componentRef}
            documentTitle="new document"
            pageStyle="print"
            className="bg-success"
          />
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <div ref={(el) => (componentRef = el)}>
        <Table striped bordered hover size="sm">
          <thead>
            <tr className="th-table">
              <th>QR Code</th>
              <th>Status Member</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Member Since</th>
              <th>Expired Date</th>
              {
                staff?.email == 'user@amospa.com' ? null :
                <th>Action</th>
              }
            </tr>
          </thead>
          <tbody>
            {dataTable.map((item, index) => {
              return (
                <tr key={index} className="table-content">
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.qr}
                  </td>
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {item?.statusMember}
                  </td>
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.name}
                  </td>
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.phone}
                  </td>
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {item.email}
                  </td>
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {moment(item.since).parseZone().format('DD-MM-YYYY')}
                  </td>
                  <td
                    onClick={() => clickLog(item.id)}
                    style={{ cursor: "pointer" }}
                  >
                    {moment(item.expired).parseZone().format('DD-MM-YYYY')}
                  </td>
                  {
                    staff?.email == 'user@amospa.com' ? null :
                    <td>
                      {" "}
                      <button
                        className="btn-staffid bg-danger w-100 py-2"
                        style={{ width: "70px", borderRadius: "10px" }}
                        onClick={() => handleNonActive(item.id)}
                      >
                        Stop Member
                      </button>
                    </td>
                  }
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      <div className="footer-member-list my-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-member-list-rigth me-1">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Non-Active Member ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Memberlist;
